import { createDraftSafeSelector, Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { AsyncEntityState } from "../../../Store/Thunks/asyncEntityStateUtil";
import { fetchSectionsBySystemIdsThunk } from "../../../Store/Thunks/sectionsBySystemIds";
import { RootState } from "../../../Store";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { Section } from "../LocationFeedingCalls/GQLCalls/getLfStructureCall";

const { reducer, actions, entityAdapter: sectionDataAdapter } = createAsyncEntitySlice<Section, number, SliceCaseReducers<AsyncEntityState<Section, number>>, Section>({
  name: "sections",
  reducers: {},
  fetchByIdsThunk: fetchSectionsBySystemIdsThunk,
  selectId: (section: Section) => section.section_id
})


export const sectionReducer = reducer as Reducer<AsyncEntityState<Section, number>>;
const stateSelector = (state: RootState) => state.graphQlData.sections

export const { addMany: addSections, updateOne: updateSection, updateMany: updateManySections, removeAll: clearSections, upsertMany: upsertSections, addLoadingIds, addPendingId, clearPendingIds, removeOne: removeSectionFromRedux } = actions;
export const { selectById: selectSectionByID, selectAll: selectAllSections } = sectionDataAdapter.getSelectors(stateSelector)

export const selectSectionsBySystem = createDraftSafeSelector(selectAllSections, (_, system_id: number) => system_id, (sections: Section[], system_id: number) => sections.filter((section) => section.system_id === system_id));

const sectionFetch = new EnqueueFetcher(fetchSectionsBySystemIdsThunk, stateSelector, clearPendingIds, addPendingId, addLoadingIds);

export const dispatchFetchSectionBySystem = sectionFetch.enqueueFetchById;
